import React, { useState } from 'react';
import { MaterialReactTable, MRT_Row } from 'material-react-table';
import { ColumnSizing, useTablesContext } from '../../../store/tables/tables-context';

import './DisputesDetailPanel.scss';

export const DisputesDetailPanel = (props: MRT_Row): React.ReactElement => {

    const { tablesContextState } = useTablesContext();
    const { columnSizing, density, data: columnData } = tablesContextState.disputesTablePanelData;

    const [disputesTableColumnSizing, setColumnsSize] = useState<ColumnSizing>(columnSizing);

    const options = {
        columns: columnData,
            // @ts-ignore
        data: props?.row?.original?.disputeActivities || [],
        // data: disputes,
        enableColumnResizing: false,
        enableColumnActions: false,
        enableColumnFilters: false,
        enableGlobalFilter: false,
        enableGlobalFilterModes: false,
        enableFilters: false,
        enablePagination: false,
        manualSorting: false,
        manualFiltering: false,
        manualPagination: false,
        enableHiding: false,
        enableFullScreenToggle: false,
        onColumnSizingChange: setColumnsSize,
        enableDensityToggle: false,
        // initialState: {
        //     // columnSizing: columnSizing,
        //     density: 'compact' as MRT_DensityState,
        // },
        state: {
            columnSizing: disputesTableColumnSizing,
            // density,
        },
        options: {
            toolbar: false,
        },
        enableBottomToolbar: false,
    };

    // @ts-ignore
    const disputeActivities = props?.row?.original?.disputeActivities;

    return (
        <div className="fc-table-panel">
            {/*<div className="fw-bolder fs-5">*/}
            {/*    Activities*/}
            {/*</div>*/}
            {
                // @ts-ignore
                (!disputeActivities || disputeActivities && disputeActivities?.length === 0) && (
                    <div style={{ padding: '15px' }}>No records to display</div>
                )
            }
            {
              disputeActivities && disputeActivities?.length > 0 && (
                    <div className="fc-disputes-table-panel-wrapper">
                        <MaterialReactTable
                            {...options}
                        />
                    </div>
                )
            }
        </div>
    );
};
